<!-- components/admin/ScoreSubAdmin.vue -->
<!-- แสดง sub-score (ด้านที่ 1, ด้านที่ 2) ในตาราง Admin -->
<!-- เกณฑ์เดิม: แสดงคะแนนตัวเลข + สีเขียว/แดง -->
<!-- เกณฑ์ใหม่: แสดง "-" เพราะไม่ใช้คะแนนตัวเลข -->
<template>
  <div class="score-sub-admin text-center">
    <!-- เกณฑ์ใหม่: ไม่มี sub-score -->
    <span v-if="criteriaVersion === 'NEW'" class="grey--text text--lighten-1"
      >-</span
    >

    <!-- เกณฑ์เดิม: แสดงคะแนน -->
    <template v-else>
      <span
        v-if="total > 0"
        class="font-weight-medium"
        :class="score >= threshold ? 'success--text' : 'error--text'"
      >
        {{ score }}
      </span>
    </template>
  </div>
</template>

<script>
export default {
  name: "ScoreSubAdmin",
  props: {
    score: {
      type: [Number, String],
      default: 0
    },
    total: {
      type: [Number, String],
      default: 0
    },
    threshold: {
      type: Number,
      required: true
    },
    criteriaVersion: {
      type: String,
      default: "OLD"
    }
  }
};
</script>

<style scoped>
.score-sub-admin {
  min-width: 40px;
}
</style>